import * as React from "react";
import type { SVGProps } from "react";
const SvgHalfscreenOffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="halfscreen_off_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M926.165 158.165 742.997 341.333h96.128a42.667 42.667 0 1 1 0 85.334H640A42.667 42.667 0 0 1 597.333 384V184.875a42.667 42.667 0 1 1 85.334 0v96.128L865.835 97.835a42.667 42.667 0 1 1 60.33 60.33zm-828.33 768a42.667 42.667 0 0 0 60.33 0l183.04-183.04v96.128a42.667 42.667 0 1 0 85.334 0V643.456a42.581 42.581 0 0 0-45.995-45.995H184.747a42.667 42.667 0 1 0 0 85.334h96.128l-183.04 183.04a42.667 42.667 0 0 0 0 60.33z"
    />
  </svg>
);
export default SvgHalfscreenOffIcon;
